import React from "react";

const About = () => {
    return (
        <div>
            <h1>About</h1>

            <p className="">Unity and C# developer with a great passion for crafting immersive experiences that enable
                players to
                engage in stories fostering empathy and addressing contemporary global issues. Focusing on efficient and
                modular development that lets my project iterate quickly.</p>
        </div>
    );
};

export default About;
